import DOMPurify from "dompurify";
import cn from "classnames";
import { specialOfferApi } from "@rshbintech.dboul/http";
import commonStyles from "../../../../styles.scss";
import { useMicroserviceAvailable } from "../../../../../hooks";
import { MICROSERVICES_NAMES } from "../../../../../common/constants";
import { ImageTextBlockVerticalProps } from "./types";
import styles from "./styles.scss";

export const ImageTextBlockVertical = ({
  title,
  blocks,
  size,
}: ImageTextBlockVerticalProps) => {
  const isSpecialOffersTemplatesMicroserviceAvailable =
    useMicroserviceAvailable(MICROSERVICES_NAMES.SPECIAL_OFFERS_TEMPLATES);

  return (
    <div className={styles.block}>
      {!!title && (
        <h4
          className={styles["block-title"]}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(title),
          }}
        />
      )}
      <div
        className={cn(styles["block-content"], styles[`block-content-${size}`])}
        style={{ marginTop: title ? "48px" : "0" }}
      >
        {blocks.map((block) => {
          const imageAltProp = block.image?.name;

          return (
            <div
              className={cn(
                styles["block-content-item"],
                styles[`block-content-${size}-item`]
              )}
            >
              <img
                alt={imageAltProp}
                className={styles[`block-content-${size}-item-icon`]}
                src={`${specialOfferApi.baseUrl}/api/special-offers/${
                  isSpecialOffersTemplatesMicroserviceAvailable ? "v2" : "v1"
                }/external/special-offers/image/${block.image?.id}`}
              />
              <p
                className={cn(
                  styles[`block-content-${size}-item-title`],
                  commonStyles["size-medium-long"]
                )}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(block.title),
                }}
              />
              <p
                className={cn(
                  styles[`block-content-${size}-item-text`],
                  commonStyles["size-medium-long"]
                )}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(block.text),
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
